/**
 * Convert a masked US date of birth (MM/DD/YYYY, as collected by
 * MaskedDateOfBirthInput) to the ISO 8601 calendar date (YYYY-MM-DD) the CMS
 * Integration Service / FHIR Patient.birthDate expects.
 *
 * Returns '' for any value that is not a complete 10-character MM/DD/YYYY
 * string, so callers can guard against firing a request with a malformed date.
 */
export const toIsoBirthDate = (mmddyyyy: string): string => {
  // Structural check: exactly MM/DD/YYYY with digits only. This is an exported
  // utility feeding a CMS FHIR field directly, so it must not assume the caller
  // (MaskedDateOfBirthInput) already sanitized the value.
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(mmddyyyy)) return '';
  const [month, day, year] = mmddyyyy.split('/');
  const m = Number(month);
  const d = Number(day);
  // Reject impossible month/day (e.g. "13/45/2020") before it reaches CMS.
  if (m < 1 || m > 12 || d < 1 || d > 31) return '';
  return `${year}-${month}-${day}`;
};
